import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  cursor: pointer;
  margin-top: 16px;
  text-align: center;
`;

const ClickableText = styled.div`
  color: var(--text-color-light-gray);
  font-size: 14px;
  font-weight: bold;
  line-height: 1.5;
`;

const BlueText = styled.span`
  color: var(--brand-blue);
  font-weight: bold;
`;

const EmailHeader = styled.div`
  color: var(--text-color-light-gray);
  font-size: 14px;
  font-weight: bold;
  margin-top: 4px;
`;
const EmailText = styled.div`
  color: var(--brand-blue);
  font-size: 14px;
  font-weight: bold;
  margin-top: 4px;
`;

const ShowEmailButton = ({ email }) => {
  const [isEmailVisible, setIsEmailVisible] = useState(false);

  const handleClick = () => {
    setIsEmailVisible(true);
  };

  return (
    <Wrapper onClick={handleClick}>
      {isEmailVisible ? (
        <>
          <EmailHeader>E-MAIL PRZYPISANY DO KONTA:</EmailHeader>
          <EmailText>{email.toUpperCase()}</EmailText>
        </>
      ) : (
        <ClickableText>
          <BlueText>KLIKNIJ </BlueText>
          I WYŚWIETL E-MAIL
          <br />
          PRZYPISANY DO TWOJEGO KONTA
        </ClickableText>
      )}
    </Wrapper>
  );
};

ShowEmailButton.propTypes = {
  email: PropTypes.string.isRequired,
};

export default ShowEmailButton;
